import { EDayOfWeek } from '../Enum/EDayOfWeek';
import { EMonth } from '../Enum/EMonth';
import { ERating } from '../Enum/ERating';
import { EDeliveryState } from '../Enum/EDeliveryState';
import { EUserRole } from '../Enum/EUserRole';
import { EComplaintTemplateDirection } from '../Enum/EComplaintTemplateDirection';
import { EEntityType } from '../Enum/EEntityType';
import { ETenderOperationType } from '../Enum/ETenderOperationType';
import { ETenderState } from '../Enum/ETenderState';
import { EComplaintState } from '../Enum/EComplaintState';
import { EComplaintCommentState } from '../Enum/EComplaintCommentState';
import { ECalendarEntryType } from '../Enum/ECalendarEntryType';
import { EReportType } from '../Enum/EReportType';
import { ERequestForDeliveryAssigner} from '../Enum/ERequestForDeliveryAssigner';
import { ERestorePasswordResult} from '../Enum/ERestorePasswordResult';
import { ERegisterResult} from '../Enum/ERegisterResult';
import { EUpdatePasswordResult} from '../Enum/EUpdatePasswordResult';
import { ERoutePointType} from '../Enum/ERoutePointType';
import { ERatingType} from '../Enum/ERatingType';
import { EApiRequestDirection } from '../Enum/EApiRequestDirection';
import { EComplaintCommentDirection } from '../Enum/EComplaintCommentDirection';
import { EDeliveryCompletionState } from '../Enum/EDeliveryCompletionState';
import { EWithdrawOwner } from '../Enum/EWithdrawOwner';
import { EDriverScoreKind } from '../Enum/EDriverScoreKind';
import { EDeliveryStateSource } from '../Enum/EDeliveryStateSource';
import { ECargoTransporterRatingReportType } from '../Enum/ECargoTransporterRatingReportType';
import { EOperationType } from '../Enum/EOperationType';
import { RouteSegmentDTO } from './RouteSegmentDTO';
import { GeoCoordinateDTO } from './GeoCoordinateDTO';



export class DeliveryStateDTO {
	public DeliveryState?: EDeliveryState = undefined;
	public UserId?: string = undefined;
	public CommentsForShipper?: string = undefined;
	public CommentsForCargoTransporter?: string = undefined;
	public CargoTransporterId?: string = undefined;
	public TenderId?: string = undefined;
	public Assigner?: ERequestForDeliveryAssigner = undefined;
	public DeliveryId?: string = undefined;
	public DeliveryRoute?: RouteSegmentDTO = undefined;
	public BiddingId?: string = undefined;
	public IsBetExceededRate?: boolean = undefined;
	public BiddingStart?: Date = undefined;
	public BiddingEnd?: Date = undefined;
	public VehicleId?: string = undefined;
	public DriverId?: string = undefined;
	public ContainerId?: string = undefined;
	public Timestamp?: Date = undefined;
	public FileId?: string = undefined;
	public OldValues?: string = undefined;
	public NewValues?: string = undefined;
	public Rate?: number = undefined;
	public OrderNum?: number = undefined;
	public WithdrawOwner?: EWithdrawOwner = undefined;
	public StateSource?: EDeliveryStateSource = undefined;
	public DriverLocation?: GeoCoordinateDTO = undefined;
	public MultiCargoTransporterId?: string = undefined;
	public Id?: string = undefined;
}
 
